<template>
  <component v-if="visible" :is="rootTag" v-html="htmlBody"></component>
</template>

<script setup lang="ts">
import usePart, {type PartProps, partProps} from "../Part";
import {computed} from "vue";
import type {Html} from "@t/fd/fixed/Html";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const html = computed<Html>(() => props.part as Html);
const { visible, valueExpression } = usePart(props);

const htmlBody = valueExpression("value", "ex");

const rootTag = computed(() => {
  return html.value.tag ? html.value.tag : "div";
});

</script>

<style scoped>

</style>
